import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ReceiveMaterialListRes;
export const ReceiveMaterialListTodo = createAsyncThunk('ReceiveMaterialList', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'imt_receive_list',
            headers: { "Content-Type": "application/json" },
            data:{
            
                "iware_house_id": localStorage.getItem('iware_house_id'),
                "imt_status": "P",
                "vcust_plant_code": ""
            },
        })
        return ReceiveMaterialListRes = res.data

    } catch (error) {
        return ReceiveMaterialListRes = error.response.data
    }
});

const ReceiveMaterialListSlice = createSlice({
    name: 'ReceiveMaterialList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ReceiveMaterialListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ReceiveMaterialListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ReceiveMaterialListSlice.reducer; 